import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../services/apis/usuario/auth.service';
import { AcessoBloqueadoModalComponent } from '../components/acesso-bloqueado-modal/acesso-bloqueado-modal.component';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const dialog = inject(MatDialog);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        const mensagem: string =
          error.error?.errorDescription ?? 'Acesso negado.';

        const dialogRef = dialog.open(AcessoBloqueadoModalComponent, {
          width: '420px',
          disableClose: true,
          data: { mensagem },
        });

        dialogRef.afterClosed().subscribe(() => authService.logout());
      }

      return throwError(() => error);
    })
  );
};
